"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TcPropertiesDtoToJSON = exports.TcPropertiesDtoFromJSONTyped = exports.TcPropertiesDtoFromJSON = exports.instanceOfTcPropertiesDto = exports.TcPropertiesDtoBiradsEnum = exports.TcPropertiesDtoBreastDensityAssessmentTypeEnum = exports.TcPropertiesDtoHrtTypeEnum = exports.TcPropertiesDtoHrtWhenEnum = exports.TcPropertiesDtoBrca2TestResultEnum = exports.TcPropertiesDtoBrca1TestResultEnum = exports.TcPropertiesDtoMenopausalStatusEnum = void 0;
var runtime_1 = require("../runtime");
var FamilyHistoryDto_1 = require("./FamilyHistoryDto");
/**
 * @export
 */
exports.TcPropertiesDtoMenopausalStatusEnum = {
    PreMenopausal: 'PreMenopausal',
    PeriMenopausal: 'PeriMenopausal',
    PostMenopausal: 'PostMenopausal',
    Menopausal: 'Menopausal'
};
/**
 * @export
 */
exports.TcPropertiesDtoBrca1TestResultEnum = {
    Negative: 'Negative',
    Positive: 'Positive',
    Vus: 'VUS'
};
/**
 * @export
 */
exports.TcPropertiesDtoBrca2TestResultEnum = {
    Negative: 'Negative',
    Positive: 'Positive',
    Vus: 'VUS'
};
/**
 * @export
 */
exports.TcPropertiesDtoHrtWhenEnum = {
    PreviousLessThanFive: 'PreviousLessThanFive',
    PreviousGreaterThanEqualFive: 'PreviousGreaterThanEqualFive',
    Current: 'Current',
    Unknown: 'Unknown'
};
/**
 * @export
 */
exports.TcPropertiesDtoHrtTypeEnum = {
    Estrogen: 'Estrogen',
    Combined: 'Combined'
};
/**
 * @export
 */
exports.TcPropertiesDtoBreastDensityAssessmentTypeEnum = {
    Birads: 'Birads',
    Vas: 'Vas',
    Volpara: 'Volpara'
};
/**
 * @export
 */
exports.TcPropertiesDtoBiradsEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D'
};
/**
 * Check if a given object implements the TcPropertiesDto interface.
 */
function instanceOfTcPropertiesDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfTcPropertiesDto = instanceOfTcPropertiesDto;
function TcPropertiesDtoFromJSON(json) {
    return TcPropertiesDtoFromJSONTyped(json, false);
}
exports.TcPropertiesDtoFromJSON = TcPropertiesDtoFromJSON;
function TcPropertiesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'menopausalStatus': !(0, runtime_1.exists)(json, 'menopausalStatus') ? undefined : json['menopausalStatus'],
        'brca1TestResult': !(0, runtime_1.exists)(json, 'brca1TestResult') ? undefined : json['brca1TestResult'],
        'brca2TestResult': !(0, runtime_1.exists)(json, 'brca2TestResult') ? undefined : json['brca2TestResult'],
        'hrtWhen': !(0, runtime_1.exists)(json, 'hrtWhen') ? undefined : json['hrtWhen'],
        'hrtType': !(0, runtime_1.exists)(json, 'hrtType') ? undefined : json['hrtType'],
        'familyHistory': !(0, runtime_1.exists)(json, 'familyHistory') ? undefined : (json['familyHistory'].map(FamilyHistoryDto_1.FamilyHistoryDtoFromJSON)),
        'breastDensityAssessmentType': !(0, runtime_1.exists)(json, 'breastDensityAssessmentType') ? undefined : json['breastDensityAssessmentType'],
        'birads': !(0, runtime_1.exists)(json, 'birads') ? undefined : json['birads'],
        'weight': !(0, runtime_1.exists)(json, 'weight') ? undefined : json['weight'],
        'heightFeet': !(0, runtime_1.exists)(json, 'heightFeet') ? undefined : json['heightFeet'],
        'heightInches': !(0, runtime_1.exists)(json, 'heightInches') ? undefined : json['heightInches'],
        'menopausalAge': !(0, runtime_1.exists)(json, 'menopausalAge') ? undefined : json['menopausalAge'],
        'menarcheAge': !(0, runtime_1.exists)(json, 'menarcheAge') ? undefined : json['menarcheAge'],
        'ageAtFirstLiveBirth': !(0, runtime_1.exists)(json, 'ageAtFirstLiveBirth') ? undefined : json['ageAtFirstLiveBirth'],
        'isParous': !(0, runtime_1.exists)(json, 'isParous') ? undefined : json['isParous'],
        'isBRCAStatus': !(0, runtime_1.exists)(json, 'isBRCAStatus') ? undefined : json['isBRCAStatus'],
        'isHyperplasia': !(0, runtime_1.exists)(json, 'isHyperplasia') ? undefined : json['isHyperplasia'],
        'isADH': !(0, runtime_1.exists)(json, 'isADH') ? undefined : json['isADH'],
        'isLCIS': !(0, runtime_1.exists)(json, 'isLCIS') ? undefined : json['isLCIS'],
        'isPriorBiopsyResultsUnknown': !(0, runtime_1.exists)(json, 'isPriorBiopsyResultsUnknown') ? undefined : json['isPriorBiopsyResultsUnknown'],
        'isHRT': !(0, runtime_1.exists)(json, 'isHRT') ? undefined : json['isHRT'],
        'hrtTimeSinceLast': !(0, runtime_1.exists)(json, 'hrtTimeSinceLast') ? undefined : json['hrtTimeSinceLast'],
        'hrtLengthOfTime': !(0, runtime_1.exists)(json, 'hrtLengthOfTime') ? undefined : json['hrtLengthOfTime'],
        'hrtFuturePlanned': !(0, runtime_1.exists)(json, 'hrtFuturePlanned') ? undefined : json['hrtFuturePlanned'],
        'maternalAuntCount': !(0, runtime_1.exists)(json, 'maternalAuntCount') ? undefined : json['maternalAuntCount'],
        'paternalAuntCount': !(0, runtime_1.exists)(json, 'paternalAuntCount') ? undefined : json['paternalAuntCount'],
        'sisterCount': !(0, runtime_1.exists)(json, 'sisterCount') ? undefined : json['sisterCount'],
        'daughterCount': !(0, runtime_1.exists)(json, 'daughterCount') ? undefined : json['daughterCount'],
        'isBreastDensityAssessed': !(0, runtime_1.exists)(json, 'isBreastDensityAssessed') ? undefined : json['isBreastDensityAssessed'],
        'volpara': !(0, runtime_1.exists)(json, 'volpara') ? undefined : json['volpara'],
        'vas': !(0, runtime_1.exists)(json, 'vas') ? undefined : json['vas'],
        'polygenicRiskScore': !(0, runtime_1.exists)(json, 'polygenicRiskScore') ? undefined : json['polygenicRiskScore'],
    };
}
exports.TcPropertiesDtoFromJSONTyped = TcPropertiesDtoFromJSONTyped;
function TcPropertiesDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'menopausalStatus': value.menopausalStatus,
        'brca1TestResult': value.brca1TestResult,
        'brca2TestResult': value.brca2TestResult,
        'hrtWhen': value.hrtWhen,
        'hrtType': value.hrtType,
        'familyHistory': value.familyHistory === undefined ? undefined : (value.familyHistory.map(FamilyHistoryDto_1.FamilyHistoryDtoToJSON)),
        'breastDensityAssessmentType': value.breastDensityAssessmentType,
        'birads': value.birads,
        'weight': value.weight,
        'heightFeet': value.heightFeet,
        'heightInches': value.heightInches,
        'menopausalAge': value.menopausalAge,
        'menarcheAge': value.menarcheAge,
        'ageAtFirstLiveBirth': value.ageAtFirstLiveBirth,
        'isParous': value.isParous,
        'isBRCAStatus': value.isBRCAStatus,
        'isHyperplasia': value.isHyperplasia,
        'isADH': value.isADH,
        'isLCIS': value.isLCIS,
        'isPriorBiopsyResultsUnknown': value.isPriorBiopsyResultsUnknown,
        'isHRT': value.isHRT,
        'hrtTimeSinceLast': value.hrtTimeSinceLast,
        'hrtLengthOfTime': value.hrtLengthOfTime,
        'hrtFuturePlanned': value.hrtFuturePlanned,
        'maternalAuntCount': value.maternalAuntCount,
        'paternalAuntCount': value.paternalAuntCount,
        'sisterCount': value.sisterCount,
        'daughterCount': value.daughterCount,
        'isBreastDensityAssessed': value.isBreastDensityAssessed,
        'volpara': value.volpara,
        'vas': value.vas,
        'polygenicRiskScore': value.polygenicRiskScore,
    };
}
exports.TcPropertiesDtoToJSON = TcPropertiesDtoToJSON;
